import { css } from '@emotion/react';

/**
 * 전자결재 본문 + 가이드 텍스트 영역용 list 스타일 (wrapper styled 에 mixin).
 * 클래스명은 일반명사지만 항상 wrapper 자손 selector 로 매칭돼 타 영역과 충돌 없음.
 */
export const approvalListStyles = css`
  & .list-style-disc {
    list-style-type: disc;
  }
  & .list-style-circle {
    list-style-type: circle;
  }
  & .list-style-square {
    list-style-type: square;
  }
  & .list-style-disc,
  & .list-style-circle,
  & .list-style-square {
    list-style-position: outside;
    padding-left: 1.2em;
    text-indent: -0.3em;
  }
  & .list-style-disc li::marker,
  & .list-style-circle li::marker,
  & .list-style-square li::marker {
    font-size: 0.8em;
    line-height: 0.8em;
  }

  & .list-style-decimal {
    list-style-type: decimal;
    list-style-position: outside;
    padding-left: 1.2em;
  }
  & .list-style-decimal li::marker {
    font-variant-numeric: tabular-nums;
  }
`;

/** TinyMCE content_style 등 emotion css 객체를 못 받는 외부 컨텍스트용 raw string 버전 */
export const approvalListStylesText = `
  .list-style-disc {
    list-style-type: disc;
  }
  .list-style-circle {
    list-style-type: circle;
  }
  .list-style-square {
    list-style-type: square;
  }
  .list-style-disc,
  .list-style-circle,
  .list-style-square {
    list-style-position: outside;
    padding-left: 1.2em;
    text-indent: -0.3em;
  }
  .list-style-disc li::marker,
  .list-style-circle li::marker,
  .list-style-square li::marker {
    font-size: 0.8em;
    line-height: 0.8em;
  }

  .list-style-decimal {
    list-style-type: decimal;
    list-style-position: outside;
    padding-left: 1.2em;
  }
  .list-style-decimal li::marker {
    font-variant-numeric: tabular-nums;
  }
`;
